import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavHeaderService {
  public notificationPanelOpened = false;
  public hasUnread = false;
  constructor() {}
}
